import { TestnetChain } from '../../types'

interface ChainConstants {
  chainId: string
  usdcContract: string
  explorerUrl: string
}

export const CHAIN_CONSTANTS: Record<TestnetChain, ChainConstants> = {
  [TestnetChain.EthereumSepolia]: {
    chainId: '11155111',
    usdcContract: '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238',
    explorerUrl: 'https://sepolia.etherscan.io',
  },
  [TestnetChain.ArbitrumSepolia]: {
    chainId: '421614',
    usdcContract: '0x75faf114eafb1BDbe2F0316DF893fd58CE46AA4d',
    explorerUrl: 'https://sepolia.arbiscan.io',
  },
  [TestnetChain.BaseSepolia]: {
    chainId: '84532',
    usdcContract: '0x036CbD53842c5426634e7929541eC2318f3dCF7e',
    explorerUrl: 'https://sepolia.basescan.org',
  },
  [TestnetChain.SolanaDevnet]: {
    chainId: 'devnet',
    usdcContract: 'Gh9ZwEmdLJ8DscKNTkTqPbNwLNNBjuSzaG9Vp2KGtKJr',
    explorerUrl: 'https://explorer.solana.com/?cluster=devnet',
  },
}

export const SAFETY_CONFIG = {
  TEST_AMOUNT: '0',
  getExpiredTimestamp: (): number => Math.floor(Date.now() / 1000) - 3600,
  BURN_ADDRESS_EVM: '0x000000000000000000000000000000000000dead',
  BURN_ADDRESS_SOLANA: '11111111111111111111111111111111',
  TEST_MEMO_PREFIX: 'CPN_TEST_',
} as const

export const EIP1559_SAFETY_CONFIG = {
  SAFE_GAS_LIMIT: '0x186a0',
  SAFE_MAX_FEE_PER_GAS: '0x4a817c800',
  SAFE_MAX_PRIORITY_FEE: '0x3b9aca00',
  SAFE_VALUE: '0x0',
  SAFE_TO_ADDRESS:
    '0x000000000000000000000000000000000000dead' as `0x${string}`,
  SAFE_DATA:
    '0xa9059cbb000000000000000000000000000000000000000000000000000000000000dead0000000000000000000000000000000000000000000000000000000000000000' as `0x${string}`,
  getSafeNonce: (): `0x${string}` => {
    const hoursAgo = 24
    const avgBlockTime = 12
    const blocksAgo = (hoursAgo * 3600) / avgBlockTime
    const nonce = Math.max(0, Math.floor(Date.now() / 1000) - blocksAgo)
    return `0x${nonce.toString(16)}`
  },
} as const

export const CPN_EIP712_TYPES = {
  EIP712Domain: [
    { name: 'name', type: 'string' },
    { name: 'version', type: 'string' },
    { name: 'chainId', type: 'uint256' },
    { name: 'verifyingContract', type: 'address' },
  ],
  TransferWithAuthorization: [
    { name: 'from', type: 'address' },
    { name: 'to', type: 'address' },
    { name: 'value', type: 'uint256' },
    { name: 'validAfter', type: 'uint256' },
    { name: 'validBefore', type: 'uint256' },
    { name: 'nonce', type: 'bytes32' },
  ],
} as const
